import React, { ReactNode } from 'react';
import {
  FlexViewPrimitive,
  type FlexViewPrimitiveProps,
} from '../FlexView/FlexView.styles';
import { AccessorizedViewContent } from './AccessorizedView.styles';

export interface AccessorizedProps {
  startAccessory?: ReactNode;
  startAccessoryProps?: React.HTMLAttributes<HTMLDivElement>;
  endAccessory?: ReactNode;
  endAccessoryProps?: React.HTMLAttributes<HTMLDivElement>;
}

interface AccessorizedViewProps
  extends Omit<FlexViewPrimitiveProps, '$gap'>, AccessorizedProps {
  gap: number;
}

export const AccessorizedView = ({
  gap = 1,
  startAccessory,
  startAccessoryProps,
  endAccessory,
  endAccessoryProps,
  children,
  ...props
}: AccessorizedViewProps) => {
  return (
    <FlexViewPrimitive {...props} $gap={gap} $alignItems="center">
      {startAccessory && <div {...startAccessoryProps}>{startAccessory}</div>}
      <AccessorizedViewContent>{children}</AccessorizedViewContent>
      {endAccessory && <div {...endAccessoryProps}>{endAccessory}</div>}
    </FlexViewPrimitive>
  );
};
